import { SyntheticEvent } from 'react';

export enum TableFilterType {
  CHECKBOX = 'checkbox',
  DATE = 'date',
  AUTOCOMPLETE = 'autocomplete',
  MULTIPLE_AUTOCOMPLETE = 'multiple-autocomplete',
}

export interface TableFilterOptionItem {
  id: string;
  label: string;
}

export interface TableFilterOption {
  id: string;
  name: string;
  type: TableFilterType;
  options?: TableFilterOptionItem[];
}
export interface TableFilters {
  [key: string]: TableFilterOptionItem[] | [];
}

export type TableFilterOptions = TableFilterOption[];

export interface FilterComponentProps {
  options?: TableFilterOptionItem[];
  filterId: string;
}

export type GenericAutocompleteNewValues = TableFilterOptionItem | TableFilterOptionItem[] | null;

export type GenericAutocompleteOnChange = (_event: SyntheticEvent, newValues: GenericAutocompleteNewValues) => void;
export type TableFiltersChangeCallback = (filters: TableFilters) => void;

/** Sentinel id for "All" option — when present in a filter's selection the filter should be omitted from the query. */
export const allFilterOption = { id: '', label: 'All' };

export const resolveFilterValues = (selected: TableFilterOptionItem[]): string[] =>
  selected.some((item) => item.label === allFilterOption.label) ? [] : selected.map((item) => item.label);
